// Readiness Category constants, shared between the profile editor,
// pillar directory filter, pillar card badge and the pillar profile page.
// Keep in sync with READINESS_CATEGORIES in /app/backend/server.py.

export const READINESS_CATEGORIES = [
    {
        key: 'A',
        title: 'Relief & Grounding',
        subtitle: 'Foundational — Matrix Awareness',
        description: 'For clients dealing with immediate friction, emotional triggers, relationship conflicts, or feeling stuck.',
        // Tailwind utility classes used for the small badge + larger profile card
        badgeClass: 'bg-[#E8F2EC] text-[#2F5D4A] border-[#2F5D4A]/20',
        dotClass: 'bg-[#2F5D4A]',
    },
    {
        key: 'B',
        title: 'Self-Inquiry & Pattern Recognition',
        subtitle: 'Deepening — Wholeness & Oneness',
        description: 'For clients looking to decode repeating loops, release shame or guilt, or integrate shadow dynamics.',
        badgeClass: 'bg-[#EFEAF8] text-[#5B2D8E] border-[#5B2D8E]/20',
        dotClass: 'bg-[#5B2D8E]',
    },
    {
        key: 'C',
        title: 'Sovereignty & Conscious Play',
        subtitle: 'Integration — Non-Duality & Lila',
        description: 'For clients navigating identity transitions, embodiment, or living as a conscious creator.',
        badgeClass: 'bg-[#FBF2DF] text-[#8A6B1F] border-[#D4AF37]/40',
        dotClass: 'bg-[#D4AF37]',
    },
];

const BY_KEY = Object.fromEntries(READINESS_CATEGORIES.map(c => [c.key, c]));
export const getReadinessCategory = (key) => BY_KEY[(key || '').toString().toUpperCase()] || null;
